import React from 'react';
import Line from '../../utils/Line/Line';
import { ObjectTypes } from '../TorgaRouter';
import { TorgaContext } from '../TorgaContext';
import { Button } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { actionRoutineAddActivity } from '../Routine/actions';
import { PropTypes } from 'prop-types';

export default function ActivitySelector({ routineID }) {
  const [isSelectorOpen, openSelector] = React.useState(false);
  const { state, dispatchAction } = React.useContext(TorgaContext);

  return (
    <div>
      <Button icon={IconNames.ADD} onClick={() => openSelector(true)}>
        {' '}
        Add Activity{' '}
      </Button>

      {isSelectorOpen && (
        <Line
          type={ObjectTypes.ACTIVITIES}
          id={state.activities.rootID}
          context={TorgaContext}
          prefix={'A'}
          onSelect={(id) => {
            openSelector(false);
            dispatchAction(actionRoutineAddActivity(routineID, id));
          }}
        ></Line>
      )}
    </div>
  );
}

ActivitySelector.propTypes = {
  routineID: PropTypes.number.isRequired,
};
